import { GetterTree } from 'vuex'

import State, { User } from './types'

import { RootState } from '../types'
export const getters: GetterTree<State, RootState> = {
  canRead: (state) => (moduleId: number) => state.currentUser?.EffectivePermissions?.some(p => p.ModuleId === moduleId && p.CanRead) || false,
  canWrite: (state) => (moduleId: number) => state.currentUser?.EffectivePermissions?.some(p => p.ModuleId === moduleId && p.CanRead) || false,
  canDelete: (state) => (moduleId: number) => state.currentUser?.EffectivePermissions?.some(p => p.ModuleId === moduleId && p.CanRead) || false,
  canExecute: (state) => (moduleId: number) => state.currentUser?.EffectivePermissions?.some(p => p.ModuleId === moduleId && p.CanRead) || false,
  currentUser(state): User {
    const { currentUser } = state
    return currentUser
  },
}
